import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import MobileHeader from '@pcln/mobile-header'
import StyledContent from './StyledContent'
import BootstrapDataContext from '../../context/BootstrapDataContext'
import {
  ANALYTICS_CATEGORY_FLIGHTS,
  ANALYTICS_CATEGORY_PACKAGES
} from '../../constants/analytics'

const ANALYTICS_CATEGORY = {
  flights: ANALYTICS_CATEGORY_FLIGHTS,
  packages: ANALYTICS_CATEGORY_PACKAGES
}

const MobileHeaderWrapper = ({ selectedProductName }) => {
  const { key = '' } = useContext(BootstrapDataContext)
  const category = ANALYTICS_CATEGORY[key]

  const aceChildren = [
    <StyledContent name="8929BAA8AA" fallback="HOTELS" />,
    <StyledContent name="99BFB913B7" fallback="FLIGHTS" />,
    <StyledContent name="BAAEA9A05C" fallback="BUNDLE + SAVE" />,
    <StyledContent name="B6BABB8B5B" fallback="CARS" />,
    <StyledContent name="CB06524F98" fallback="CRUISES" />
  ]

  const items = MobileHeader.items.map((item, index) => {
    return { ...item, child: aceChildren[index] }
  })

  return (
    <MobileHeader
      analyticsCategory={category}
      items={items}
      selectedItem={selectedProductName}
    />
  )
}

MobileHeaderWrapper.propTypes = {
  selectedProductName: PropTypes.string.isRequired
}

export default MobileHeaderWrapper
